import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=15fdbf6a&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"
import "./EditCustomer.vue?vue&type=style&index=0&id=15fdbf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fdbf6a",
  null
  
)

export default component.exports